import React, { useCallback, useEffect, useState } from "react";
import styles from './index.module.css';
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ManagerRoutes from "../../../routes/ManagerRoutes";

const Options = () => {

    const slicedRoutes = ManagerRoutes.slice(8, 11);
    return (
        <div className={`card-section`}>
            <div className={`main-card`}>
                <div className={styles.formContainer}>
                  <div className={styles.cardRow}>
                  {slicedRoutes.map((item, index) => (
                    <Link to={`/manager/${item.path}`} className={styles.linkText}>
                    <div key={index} className={styles.linkCard}>{item.name}</div></Link>
                  ))}
                  </div>
                </div>
            </div>
        </div>
    );
};

export default Options;
